const API_BASE_URL = process.env.REACT_APP_API_URL;

export const ApiRequest = async (endpoint, method = "GET", body = null,navigate) => {
    try {
        const usrDetails = JSON.parse(localStorage.getItem("user"));
        const url = `${API_BASE_URL}${endpoint}`;
        const defaultHeaders = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${usrDetails.Token}`
        };
       
        const response = await fetch(url, {
            method,
            headers: { ...defaultHeaders}, // Merge default and custom headers
            body: body ? JSON.stringify(body) : null, // Include body only for POST, PUT, etc.
        });
        if (response.status === 401) {
            // Handle 401 Unauthorized
            localStorage.clear();  // Example for removing a token
            navigate('/');  // Redirect to login page
            return; // Stop further execution
        }

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return await response.json(); // Parse JSON response
    } catch (error) {
        console.error("API Request Error:", error);
        // throw error; // Re-throw to handle errors in the calling code
        return;
    }
};

export const ApiViewDocRequest = async (endpoint, method = "GET", body = null,navigate) => {
    try {
        const usrDetails = JSON.parse(localStorage.getItem("user"));
        const url = `${API_BASE_URL}${endpoint}`;
        const defaultHeaders = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${usrDetails.token}`
        };

        const response = await fetch(url, {
            method,
            headers: { ...defaultHeaders}, // Merge default and custom headers
            body: body ? JSON.stringify(body) : null, // Include body only for POST, PUT, etc.
        });
        if (response.status === 401) {
            // Handle 401 Unauthorized
            localStorage.clear();  // Example for removing a token
            navigate('/');  // Redirect to login page
            return; // Stop further execution
        }

        return await response; // Parse JSON response
    } catch (error) {
        console.error("API Request Error:", error);
        // throw error; // Re-throw to handle errors in the calling code
        return;
    }
};


export const ApiCostRequest = async (endpoint, method = "GET", body = null,navigate) => {
    try {
        const usrDetails = JSON.parse(localStorage.getItem("user"));
        const url = `${API_BASE_URL}${endpoint}`;
        const defaultHeaders = {
            Authorization: `Bearer ${usrDetails.token}`
        };

        const response = await fetch(url, {
            method,
            headers: { ...defaultHeaders}, // Merge default and custom headers
            body: body, // Include body only for POST, PUT, etc.
        });
        if (response.status === 401) {
            // Handle 401 Unauthorized
            localStorage.clear();  // Example for removing a token
            navigate('/');  // Redirect to login page
            return; // Stop further execution
        }

        return await response; // Parse JSON response
    } catch (error) {
        console.error("API Request Error:", error);
        // throw error; // Re-throw to handle errors in the calling code
        return;
    }
};


export const NoAuthApiRequest = async (endpoint, method = "GET", body = null) => {
    try {
        const url = `${API_BASE_URL}${endpoint}`;

        const defaultHeaders = {
            "Content-Type": "application/json",
        };

        const response = await fetch(url, {
            method,
            headers: { ...defaultHeaders}, // Merge default and custom headers
            body: body ? JSON.stringify(body) : null, // Include body only for POST, PUT, etc.
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        return await response.json(); // Parse JSON response
    } catch (error) {
        console.error("API Request Error:", error);
        throw error; // Re-throw to handle errors in the calling code
    }
};